/** Világos/sötét téma: rendszerbeállítás követése + kézi felülbírálás. */
const KEY = 'bitsquad-md:theme';
export type Theme = 'system' | 'light' | 'dark';

export function getStoredTheme(): Theme {
  const v = localStorage.getItem(KEY);
  return v === 'light' || v === 'dark' ? v : 'system';
}

export function isDark(): boolean {
  const t = getStoredTheme();
  if (t === 'system') return window.matchMedia('(prefers-color-scheme: dark)').matches;
  return t === 'dark';
}

export function applyTheme(theme: Theme = getStoredTheme()): void {
  if (theme === 'system') localStorage.removeItem(KEY);
  else localStorage.setItem(KEY, theme);
  document.documentElement.dataset.theme = theme === 'system' ? '' : theme;
}

export function toggleTheme(): void {
  applyTheme(isDark() ? 'light' : 'dark');
}
